/* tslint:disable */
/* eslint-disable */
/**
 * Order Portal
 * Order Portal
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ResultDto,
} from '../models/index';
import {
    ResultDtoFromJSON,
    ResultDtoToJSON,
} from '../models/index';

export interface BusinessPartnersControllerGetBusinessPartnerRequest {
    cardCode: string;
}

/**
 * 
 */
export class BusinessPartnersApi extends runtime.BaseAPI {

    /**
     */
    async businessPartnersControllerGetBusinessPartnerRaw(requestParameters: BusinessPartnersControllerGetBusinessPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        if (requestParameters['cardCode'] == null) {
            throw new runtime.RequiredError(
                'cardCode',
                'Required parameter "cardCode" was null or undefined when calling businessPartnersControllerGetBusinessPartner().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/business-partners/{cardCode}`;
        urlPath = urlPath.replace(`{${"cardCode"}}`, encodeURIComponent(String(requestParameters['cardCode'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async businessPartnersControllerGetBusinessPartner(requestParameters: BusinessPartnersControllerGetBusinessPartnerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.businessPartnersControllerGetBusinessPartnerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async businessPartnersControllerGetBusinessPartnersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/business-partners`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultDtoFromJSON(jsonValue));
    }

    /**
     */
    async businessPartnersControllerGetBusinessPartners(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
        const response = await this.businessPartnersControllerGetBusinessPartnersRaw(initOverrides);
        return await response.value();
    }

}
